import { storeToRefs } from 'pinia';
import { defineComponent, computed, onMounted } from 'vue';
import { usePayoutAccountsStore } from '@/store/modules/payout-accounts';
import { useAuthStore } from '@/store/modules/auth';
import { PayoutAccountsTypes } from '@/types/payout-accounts';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
var PayoutComponents = PayoutAccountsTypes.PayoutComponents;
export default defineComponent({
    name: 'SelectPayout',
    setup() {
        const payoutAccounts = usePayoutAccountsStore();
        const { currentStep, selectedPayoutMethod, hasMomoSupport, hasBankSupport, } = storeToRefs(payoutAccounts);
        const authStore = useAuthStore();
        const { partnerId, isLoggedIn } = storeToRefs(authStore);
        onMounted(() => {
            payoutAccounts.resetActivePayoutAccount();
        });
        const selectOption = (option) => {
            trackEvent(MIXPANEL_EVENTS.PAYMENT_METHOD, {
                logged_in: isLoggedIn.value,
                partner: partnerId.value,
                payment_method: option,
            });
            selectedPayoutMethod.value = option;
            currentStep.value = PayoutComponents.FormSelect;
        };
        const selectOptions = computed(() => [
            {
                title: 'Mobile Money',
                condition: hasMomoSupport.value,
                icon: require('@/assets/payout-accounts/momo.svg'),
                iconAlt: 'mobile',
                onClick: () => selectOption('momo'),
            },
            {
                title: 'Bank Transfer',
                condition: hasBankSupport.value,
                icon: require('@/assets/payout-accounts/bank.svg'),
                iconAlt: 'bank',
                onClick: () => selectOption('bank'),
            },
        ]);
        const hasSelectOption = computed(() => selectOptions.value.some(option => option.condition));
        return {
            hasSelectOption,
            selectOptions,
        };
    },
});
